module.exports = require('./helpers/bundle-url').getBundleURL('kA4Du') + "logo-dark.eefe0b7f.svg";